export default "__VITE_ASSET__D3faMDvq__$_?path__"